import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const [modalType, setModalType] = useState(null); // 'login' | 'register' | null
  const [playNowModal, setPlayNowModal] = useState(false); // Play Now üçün ayrıca state

  const closeModal = () => setModalType(null);
  const closePlayNowModal = () => setPlayNowModal(false);

  return (
    <>
      <style>{`
        .header {
          background: url('../images/home2.png') center/cover no-repeat;
          color: white;
          position: relative;
          padding-bottom: 50px;
        }

        .navbar {
          display: flex;
          justify-content: space-around;
          align-items: center;
          padding: 20px 0;
          background-color: white;
        }

        .logo {
          font-weight: bold;
          font-size: 1.5rem;
          color: #2d00f7;
        }

        .nav-buttons .btn {
          background: #d500f9;
          color: white;
          border: none;
          margin-left: 10px;
          padding: 10px 20px;
          cursor: pointer;
          border-radius: 4px;
        }

        .hero-content {
          max-width: 600px;
          background: rgba(0, 0, 0, 0.6);
          padding: 30px;
          border-radius: 10px;
          margin: 50px 50px;
        }

        .hero-content h1 {
          font-size: 2rem;
          margin-bottom: 20px;
        }

        .hero-content p {
          font-size: 1.2rem;
          margin-bottom: 20px;
        }

        .play-now {
          background: #d500f9;
          border: none;
          color: white;
          padding: 15px 30px;
          font-size: 1rem;
          cursor: pointer;
          border-radius: 4px;
        }

        .modal-overlay {
          position: fixed;
          top: 0; left: 0;
          width: 100%; height: 100%;
          background: rgba(0, 0, 0, 0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }

        .modal {
          background: white;
          padding: 30px 20px;
          border-radius: 8px;
          width: 320px;
          max-width: 90%;
          position: relative;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.4);
        }

        .modal-close {
          position: absolute;
          top: 8px;
          right: 12px;
          background: transparent;
          border: none;
          font-size: 22px;
          cursor: pointer;
        }

        .modal h2 {
          text-align: center;
          margin-top: 0;
          margin-bottom: 20px;
        }

        .modal input {
          width: 100%;
          padding: 10px;
          margin-bottom: 12px;
          border: 1px solid #ccc;
          border-radius: 4px;
        }

        .modal .submit-btn {
          width: 100%;
          padding: 12px;
          background: #d500f9;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-weight: bold;
        }

        .modal .submit-btn:hover {
          background: #a000c0;
        }

        @media (max-width: 600px) {
          .hero-content {
            margin: 20px;
            padding: 20px;
          }

          .hero-content h1 {
            font-size: 1.5rem;
          }

          .hero-content p {
            font-size: 1rem;
          }
        }
      `}</style>

      <header className={isHomePage ? 'header' : ''}>
        <nav className="navbar">
          <div className="logo">
            <Link to="/" style={{ textDecoration: 'none' }}>
              LottoMateAu
            </Link>
          </div>
          <div className="nav-buttons">
            <button className="btn" onClick={() => setModalType('login')}>Login</button>
            <button className="btn" onClick={() => setModalType('register')}>Registration</button>
          </div>
        </nav>

        {isHomePage && (
          <div className="hero-content">
            <h1>
              Test your fortune with the online <span>LottoMateAu</span> Mega Jackpot!
            </h1>
            <p>
              Join the Australian Lottery for a chance to win $5.4 million across 10 different
              cash prize levels!
            </p>
            <button className="play-now" onClick={() => setPlayNowModal(true)}>PLAY NOW</button>
          </div>
        )}
      </header>

      {/* Login/Register Modal */}
      {modalType && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>×</button>
            <h2>{modalType === 'login' ? 'Login' : 'Register'}</h2>
            <form>
              <input type="email" placeholder="Email" required />
              <input type="password" placeholder="Password" required />
              {modalType === 'register' && (
                <input type="password" placeholder="Confirm Password" required />
              )}
              <button type="submit" className="submit-btn">
                {modalType === 'login' ? 'Login' : 'Register'}
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Play Now Modal */}
      {playNowModal && (
        <div className="modal-overlay" onClick={closePlayNowModal}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closePlayNowModal}>×</button>
            <h2>Play Now</h2>
            <form>
              <input type="text" placeholder="Name" required />
              <input type="email" placeholder="Email" required />
              <button type="submit" className="submit-btn">Submit</button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
